import { useState } from 'react';

// Vite emits these as hashed files: they stay out of the JS bundle and only the picked one loads.
const BACKGROUNDS = Object.values(
	import.meta.glob<string>('../../assets/backgrounds/*.webp', {
		eager: true,
		query: '?url',
		import: 'default',
	}),
);

/** A random background for this app launch; `random` is a parameter for tests. */
export function pickBackground(random: () => number = Math.random): string | undefined {
	return BACKGROUNDS[Math.floor(random() * BACKGROUNDS.length)];
}

// Picked once per launch, so moving between screens never swaps it.
const launchBackground = pickBackground();

/** Decorative pattern behind every screen (DESIGN → Colors): fixed, so content scrolls over it. */
export function AppBackground() {
	const [loaded, setLoaded] = useState(false);
	return (
		<img
			src={launchBackground}
			alt=""
			aria-hidden
			onLoad={() => {
				setLoaded(true);
			}}
			className={`pointer-events-none fixed inset-0 -z-10 size-full object-cover transition-opacity duration-200 ${
				loaded ? 'opacity-100' : 'opacity-0'
			}`}
		/>
	);
}
